import React from 'react';
import { InventoryStockLocationSummaryCounts } from '@/renderer/types/inventory';

export function StockLocationsSummaryCards({
  summary,
}: {
  summary: InventoryStockLocationSummaryCounts;
}) {
  const cards = [
    { label: 'Total locations', value: summary.totalLocations },
    { label: 'Active', value: summary.activeLocations },
    { label: 'Inactive', value: summary.inactiveLocations },
    { label: 'Location types', value: summary.uniqueTypes },
  ];

  return (
    <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
      {cards.map((card) => (
        <div
          key={card.label}
          className="rounded-2xl border border-gray-200 bg-white px-4 py-4 shadow-sm"
        >
          <p className="text-sm text-gray-500">{card.label}</p>
          <p className="mt-2 text-2xl font-semibold text-gray-900">
            {card.value.toLocaleString()}
          </p>
        </div>
      ))}
    </div>
  );
}
